import React from 'react';
import { Form, Input, Button, Tooltip } from 'antd';
import 'react-toastify/dist/ReactToastify.css';
import styles from './reset-password.module.scss';
import logo from '@assets/images/sage-logo-login.png';
import { validatePassword } from '@services/utils';
import { useLocation, Link, useHistory } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';
import auth from '@services/api/auth';
import { toast } from 'react-toastify';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ApiError } from '@services/types';
import { getPasswordRequirementsTooltip } from '@services/passwordRecommendation';
import { AppContext } from '@layouts/AppRouter';

const ResetPassword = () => {
  const { variablesProfile } = React.useContext(AppContext);
  const [form] = Form.useForm();
  const { search } = useLocation();
  const path = React.useMemo(() => new URLSearchParams(search), [search]);
  const history = useHistory();

  const handleFinish = async () => {
    await form.validateFields();
    const obj = {
      token: path.get('token'),
      userId: path.get('userId'),
      newPassword: form.getFieldValue('newPassword'),
    };
    try {
      await auth.newPass(obj);
      toast.success('New Password was created successfully');
      form.resetFields();
      history.push(Navigation.Login);
    } catch (error) {
      if (error instanceof ApiError) {
        toast.error(`${error.error.details}`);
      } else {
        console.log(error);
      }
    }
  };

  return (
    <div className="main-login-page">
      <div className="login-wrapper">
        <img className="login-logo" src={logo} alt="Logo Sagem" />
        <Form
          className={styles.form}
          style={{ marginTop: '20px' }}
          layout="vertical"
          onFinish={handleFinish}
          form={form}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr max-content',
              gridGap: '10px',
              alignItems: 'center',
            }}
          >
            <Form.Item
              className={styles.block}
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
                () => ({
                  validator(_, value) {
                    const error = validatePassword(value, variablesProfile?.minPasswordSize);
                    if (error) {
                      return Promise.reject(new Error(error));
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}
            >
              <Input.Password placeholder="New Password" />
            </Form.Item>
            <Tooltip placement="right" title={getPasswordRequirementsTooltip(variablesProfile?.minPasswordSize)}>
              <InfoCircleOutlined />
            </Tooltip>
          </div>

          <Form.Item
            className={styles.block}
            name="confirmPassword"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Please confirm your password!',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('The two passwords that you entered do not match!'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>
          <Form.Item className={styles.block}>
            <Button type="primary" htmlType="submit">
              Confirm
            </Button>
          </Form.Item>
          <Link to={Navigation.Login}>Back to login</Link>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
